import { Placement } from '@popperjs/core/lib/enums';
import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import { Tooltip } from '@skipper/ui';

export function SkipperTooltip({
    children,
    trigger,
    placement,
}: {
    children: React.ReactNode;
    trigger: HTMLElement | null;
    placement?: Placement | null;
}) {
    const [popElement, setPopElement] = useState<null | HTMLDivElement>();
    const [arrowElement, setArrowElement] = useState<null | HTMLDivElement>(null);
    const { styles, attributes } = usePopper(trigger, popElement, {
        strategy: 'absolute',
        placement: placement ?? 'right',
        modifiers: [{ name: 'arrow', options: { element: arrowElement } }],
    });
    return (
        <div
            ref={setPopElement}
            {...attributes.popper}
            style={styles.popper}
            className="tooltip-container my-2"
        >
            {children}
            <div ref={setArrowElement} style={styles.arrow} className="tooltip-arrow" />
        </div>
    );
}

export function WithTooltip({
    children,
    content,
}: {
    children: React.ReactNode;
    content: string | JSX.Element;
}) {
    const [trigger, setTrigger] = useState<HTMLElement | null>(null);
    return (
        <Tooltip>
            <Tooltip.Trigger>{children}</Tooltip.Trigger>
            <Tooltip.Content sideOffset={0}>
                <Tooltip.Arrow />
                <div className="bg-gray-900 px-2 py-1 text-white rounded-sm text-sm font-larsseit font-[500] h-[28px] whitespace-pre-wrap">
                    {content}
                </div>
            </Tooltip.Content>
        </Tooltip>
    );
}
